<script>
import AppIcon from "@/features/general/Icons";

export default {
  name: "AppCashbackEmptyState",

  components: {
    AppIcon,
  },
};
</script>

<template>
  <div class="app__cashback__empty-state text-center py-5">
    <div class="app__cashback__empty-state__icon mb-4">
      <app-icon name="coins" prefix="fa" />
    </div>
    <h3 class="app__cashback__empty-state__title mb-2">
      Você ainda não tem créditos de cashback
    </h3>
    <p class="text-muted">
      Compre em lojas que oferecem cashback.
    </p>
  </div>
</template>
